import vertexShader from "./sky.vert";
import fragmentShader from "./sky.frag";
import {
  BackSide,
  Color,
  DoubleSide,
  ShaderMaterial,
  UniformsUtils,
  Vector3,
} from "three";
import DeviceGradeDetection, {
  DeviceGrade,
} from "../../util/DeviceGradeDetection";

export interface SkyShaderParams {
  colourSky: string;
  colourHorizon: string;
  colourHighlight: string;
  smoothstepControl: string;
}

class SkyShaderMaterial extends ShaderMaterial {
  constructor({
    colourSky,
    colourHorizon,
    colourHighlight,
    smoothstepControl,
  }: SkyShaderParams) {
    const uniforms = {
      uTime: { value: 100 }, // start at later time so sun is already partially risen
      uColourSky: { value: new Color(colourSky) },
      uColourHorizon: { value: new Color(colourHorizon) },
      uColourHighlight: { value: new Color(colourHighlight) },
      uSmoothstepControl: { value: parseFloat(smoothstepControl) },
      uFractalNoiseCount: {
        value:
          DeviceGradeDetection.deviceGrade < DeviceGrade.Medium
            ? 1
            : DeviceGradeDetection.isMobile ||
              DeviceGradeDetection.deviceGrade < DeviceGrade.High
            ? 3
            : 4,
      },
      uSunPosition: {
        value: new Vector3(1, Math.PI * 0.1, Math.PI * 0.75), // r, theta, phi (radius, latitude (colatitude), longitude (azimuthal))
      },
    };

    super({ uniforms, vertexShader, fragmentShader, side: DoubleSide });
  }

  public update(delta: number): void {
    this.uniforms.uTime.value += (1 / 60) * delta;
  }
}

export default SkyShaderMaterial;
